import styled from 'styled-components'
import CloseIcon from '@material-ui/icons/Close'
import { FC,CSSProperties } from 'react'

export const TableUtilContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 16px'
})

export const ModalTitle = styled.div`
  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
`

export const CloseIconStyle = styled(CloseIcon)`
  font-size: 20px;
`
export const CloseIconWrap = styled.span`
  cursor: pointer;
`
export const ModalCloseButton: FC<{ style?: CSSProperties,  onClick?: (e: any) => void }> = ({ onClick,style, ...props }) =>
  <CloseIconWrap style={style} {...props} onClick={onClick}>
    <CloseIconStyle />
  </CloseIconWrap>

export const MainSettingPage = styled.div`
  display: flex;
  flex-direction: row;
  flex: 0 1 100vh;
  height: 100vh;
`

export const LeftPane = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 16vw;
  /* height: 100vh; */
  /* flex-grow: 1; */
  overflow-y: auto;
  min-height: 0;
  background-color: #F9F9F9;
`

export const SettingsMainPane = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  border-right: 1px solid #E5E5E5;
  border-left: 1px solid #E5E5E5;
  /* height: calc(100vh - 60px); */
`

export const SettingsComponent = styled.div`
  /* flex: 0 1 calc(100% - 68px); */
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border-top: 1px solid #E5E5E5;
`